"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customerSourceApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var customerSourceApi = exports.customerSourceApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/customerSource",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/customerSource",
      data: data,
      method: "post"
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/customerSource/".concat(id, "/update"),
      data: data,
      method: "post"
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/customerSource/".concat(id, "/delete"),
      method: "post"
    });
  }
};